@if (form) {
  <ng-container [formGroup]="form">
    <mat-slide-toggle [color]="color" [formControlName]="formControlName" [checked]="value" (change)="handleChange($event)">
      {{ innerText }}
    </mat-slide-toggle>
    <mat-error>{{ error }}</mat-error>
  </ng-container>
} @else {
  <mat-slide-toggle [color]="color" [checked]="value" (change)="handleChange($event)">
    {{ innerText }}
  </mat-slide-toggle>
}
